'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import VideoTextCard from '@/components/VideoTextCard';
import card1Data from '../../../textContent/services/card1Data.json';
import card2Data from '../../../textContent/services/card2Data.json';
import { motion } from 'framer-motion';

/* ---------------- Animation Variant ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const Page = () => {
    const heroTextContent = {
        heading: 'The All-in-One Powerhouse for Service Businesses',
        caption:
            'Track progress, manage resources, and collaborate seamlessly across teams. Real-time insights keep you ahead of schedule and ensure client satisfaction.',
        image: '/images/hero/projects.png',
        buttonText: 'Contact Sales',
        buttonLink: '/contact-sales',
    };

    return (
        <Fragment>
            {/* Hero Section */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <Hero {...heroTextContent} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
            >
                <VideoTextCard data={card1Data} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
            >
                <VideoTextCard data={card2Data} />
            </motion.div>
        </Fragment>
    );
};

export default Page;
